
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_h2x75_26",
  "button": "awsui_button_vjswe_h2x75_30",
  "variant-normal": "awsui_variant-normal_vjswe_h2x75_82",
  "disabled": "awsui_disabled_vjswe_h2x75_100",
  "variant-primary": "awsui_variant-primary_vjswe_h2x75_107",
  "variant-link": "awsui_variant-link_vjswe_h2x75_132",
  "variant-icon": "awsui_variant-icon_vjswe_h2x75_157",
  "variant-control-group-action": "awsui_variant-control-group-action_vjswe_h2x75_182",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_h2x75_209",
  "variant-inline-icon-pointer-target": "awsui_variant-inline-icon-pointer-target_vjswe_h2x75_234",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_h2x75_259",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_h2x75_288",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_h2x75_313",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_h2x75_338",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_h2x75_368",
  "button-no-text": "awsui_button-no-text_vjswe_h2x75_481",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_h2x75_485",
  "full-width": "awsui_full-width_vjswe_h2x75_488",
  "button-compact": "awsui_button-compact_vjswe_h2x75_505",
  "icon-left": "awsui_icon-left_vjswe_h2x75_535",
  "icon-right": "awsui_icon-right_vjswe_h2x75_540",
  "icon": "awsui_icon_vjswe_h2x75_535",
  "link": "awsui_link_vjswe_h2x75_559",
  "disabled-with-reason": "awsui_disabled-with-reason_vjswe_h2x75_559"
};
  